import { render, staticRenderFns } from "./RequestDeletion.vue?vue&type=template&id=bb9ec10c&scoped=true&lang=pug&"
import script from "./RequestDeletion.vue?vue&type=script&lang=ts&"
export * from "./RequestDeletion.vue?vue&type=script&lang=ts&"
import style0 from "./RequestDeletion.vue?vue&type=style&index=0&id=bb9ec10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9ec10c",
  null
  
)

export default component.exports